import { get, set } from 'lodash'
import {
  add,
  findPercentage,
  isNumberEqual,
  multiply,
  percentage,
  subtract,
  toNumber,
  divide,
} from './math'

const manDayConstant = 'MD'

export const setLobProgress = (lob, name, value = 0) => {
  const {
    _activity_base = {},
    _last_activity_base = {},
    _cost_base = {},
    _gap = {},
    _man_day_rate,
    criteria,
    lob_revenue = 0 } = lob
  // set on activity_base and gap
  const isManDay = criteria === manDayConstant
  const manDayRate = toNumber(_man_day_rate)
  const shouldUseManDayRate = !isNumberEqual(_man_day_rate, 0)
  switch (name) {
    case 'accumulate_percentage': {
      if (isManDay) {
        const accumulatePercentage = value
        const accumulateRevenue = multiply(manDayRate, value)

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)

        const deltaPercentage = subtract(accumulatePercentage, lastAccuPercentage)
        const deltaRevenue = multiply(manDayRate, deltaPercentage)

        if (shouldUseManDayRate) {
          set(_activity_base, 'delta_percentage', deltaPercentage)
          set(_activity_base, 'delta_revenue', deltaRevenue)
          set(_activity_base, 'accumulate_revenue', accumulateRevenue)
        }
        set(_activity_base, 'accumulate_percentage', accumulatePercentage)
      } else {
        const accumulatePercentage = value
        const accumulateRevenue = percentage(lob_revenue, accumulatePercentage)

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)
        const lastAccuRevenue = get(_last_activity_base, 'accumulate_revenue', 0)

        const deltaPercentage = subtract(accumulatePercentage, lastAccuPercentage)
        const deltaRevenue = subtract(accumulateRevenue, lastAccuRevenue)

        set(_activity_base, 'delta_percentage', deltaPercentage)
        set(_activity_base, 'delta_revenue', deltaRevenue)
        set(_activity_base, 'accumulate_percentage', accumulatePercentage)
        set(_activity_base, 'accumulate_revenue', accumulateRevenue)
      }
      setGap(_gap, _activity_base, _cost_base)
      break
    }
    case 'accumulate_revenue': {
      if (isManDay) {
        const accumulatePercentage = divide(value, manDayRate)
        const accumulateRevenue = value

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)

        const deltaPercentage = subtract(accumulatePercentage, lastAccuPercentage)
        const deltaRevenue = multiply(manDayRate, deltaPercentage)

        if (shouldUseManDayRate) {
          set(_activity_base, 'delta_percentage', deltaPercentage)
          set(_activity_base, 'delta_revenue', deltaRevenue)
          set(_activity_base, 'accumulate_percentage', accumulatePercentage)
        }
        set(_activity_base, 'accumulate_revenue', accumulateRevenue)
      } else {
        const accumulatePercentage = findPercentage(value, lob_revenue)
        const accumulateRevenue = value

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)
        const lastAccuRevenue = get(_last_activity_base, 'accumulate_revenue', 0)

        const deltaPercentage = subtract(accumulatePercentage, lastAccuPercentage)
        const deltaRevenue = subtract(accumulateRevenue, lastAccuRevenue)

        set(_activity_base, 'delta_percentage', deltaPercentage)
        set(_activity_base, 'delta_revenue', deltaRevenue)
        set(_activity_base, 'accumulate_percentage', accumulatePercentage)
        set(_activity_base, 'accumulate_revenue', accumulateRevenue)
      }
      setGap(_gap, _activity_base, _cost_base)
      break
    }
    case 'delta_percentage': {
      if (isManDay) {
        const deltaPercentage = value
        const deltaRevenue = multiply(manDayRate, value)

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)

        const accumulatePercentage = add(lastAccuPercentage, deltaPercentage)
        const accumulateRevenue = multiply(manDayRate, accumulatePercentage)

        if (shouldUseManDayRate) {
          set(_activity_base, 'delta_revenue', deltaRevenue)
          set(_activity_base, 'accumulate_percentage', accumulatePercentage)
          set(_activity_base, 'accumulate_revenue', accumulateRevenue)
        }
        set(_activity_base, 'delta_percentage', deltaPercentage)
      } else {
        const deltaPercentage = value
        const deltaRevenue = percentage(lob_revenue, deltaPercentage)

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)
        const lastAccuRevenue = get(_last_activity_base, 'accumulate_revenue', 0)

        const accumulatePercentage = add(lastAccuPercentage, deltaPercentage)
        const accumulateRevenue = add(lastAccuRevenue, deltaRevenue)

        set(_activity_base, 'delta_percentage', deltaPercentage)
        set(_activity_base, 'delta_revenue', deltaRevenue)
        set(_activity_base, 'accumulate_percentage', accumulatePercentage)
        set(_activity_base, 'accumulate_revenue', accumulateRevenue)
      }
      setGap(_gap, _activity_base, _cost_base)
      break
    }
    case 'delta_revenue': {
      if (isManDay) {
        const deltaPercentage = divide(value, manDayRate)
        const deltaRevenue = value

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)

        const accumulatePercentage = add(lastAccuPercentage, deltaPercentage)
        const accumulateRevenue = multiply(manDayRate, accumulatePercentage)

        if (shouldUseManDayRate) {
          set(_activity_base, 'delta_percentage', deltaPercentage)
          set(_activity_base, 'accumulate_percentage', accumulatePercentage)
          set(_activity_base, 'accumulate_revenue', accumulateRevenue)
        }
        set(_activity_base, 'delta_revenue', deltaRevenue)
      } else {
        const deltaPercentage = findPercentage(value, lob_revenue)
        const deltaRevenue = value

        const lastAccuPercentage = get(_last_activity_base, 'accumulate_percentage', 0)
        const lastAccuRevenue = get(_last_activity_base, 'accumulate_revenue', 0)

        const accumulatePercentage = add(lastAccuPercentage, deltaPercentage)
        const accumulateRevenue = add(lastAccuRevenue, deltaRevenue)

        set(_activity_base, 'delta_percentage', deltaPercentage)
        set(_activity_base, 'delta_revenue', deltaRevenue)
        set(_activity_base, 'accumulate_percentage', accumulatePercentage)
        set(_activity_base, 'accumulate_revenue', accumulateRevenue)
      }
      setGap(_gap, _activity_base, _cost_base)
      break
    }
    default:
      break
  }
  return null
}

const setGap = (gap = {}, activityBase = {}, costBase = {}) => {
  const deltaActivityPercentage = get(activityBase, 'delta_percentage', 0)
  const deltaActivityRevenue = get(activityBase, 'delta_revenue', 0)
  const accumulateActivityPercentage = get(activityBase, 'accumulate_percentage', 0)
  const accumulateActivityRevenue = get(activityBase, 'accumulate_revenue', 0)

  const deltaCostPercentage = get(costBase, 'delta_percentage', 0)
  const deltaCostRevenue = get(costBase, 'delta_revenue', 0)
  const accumulateCostPercentage = get(costBase, 'accumulate_percentage', 0)
  const accumulateCostRevenue = get(costBase, 'accumulate_revenue', 0)

  const gapDeltaPercentage = subtract(deltaActivityPercentage, deltaCostPercentage)
  const gapDeltaRevenue = subtract(deltaActivityRevenue, deltaCostRevenue)
  const gapAccuPercentage = subtract(accumulateActivityPercentage, accumulateCostPercentage)
  const gapAccuRevenue = subtract(accumulateActivityRevenue, accumulateCostRevenue)

  set(gap, 'delta_percentage', gapDeltaPercentage)
  set(gap, 'delta_revenue', gapDeltaRevenue)
  set(gap, 'accumulate_percentage', gapAccuPercentage)
  set(gap, 'accumulate_revenue', gapAccuRevenue)
}



// WEBPACK FOOTER //
// ./src/function/project-progress.js